import React from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import LoadingIndicator from "../../../../../components/Shared/LoadingIndicator";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { OrganizationSignUpTriageStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { useOrganizationSignUpTriageController } from "../../hooks/useOrganizationSignUpTriageController";

export const OrganizationSignUpTriageStep: React.FC<StepRenderProps<
    OrganizationSignUpTriageStepValues,
    IOrganizationSignUpFlowValues
>> = ({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

        /********* React hooks *********/

        const controller = useOrganizationSignUpTriageController(values, allValues, update, submit)

        /********* Render *********/

        return (
            <LoadingIndicator />
        );
    };
